export default "__VITE_ASSET__0yFxK1Y3__"